module.exports = __webpack_public_path__ + "static/img/GREG_CHAPPELL.1334129.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREG_CHAPPELL.jpg
// module id = IOt6
// module chunks = 0